import React from 'react';

/** Public brand assets (also used as favicon / PWA icons) */
export const LOGO_FULL = '/brand/tychi-desk-logo.png';
export const LOGO_MARK = '/brand/tychi-mark.png';

/**
 * @param {'full' | 'mark'} variant
 * full = icon + wordmark + tagline; mark = TD icon only
 */
const BrandLogo = ({
  variant = 'full',
  className = '',
  alt = 'Tychi Desk',
  style,
  ...rest
}) => (
  <img
    src={variant === 'mark' ? LOGO_MARK : LOGO_FULL}
    alt={alt}
    className={`brand-logo brand-logo--${variant}${className ? ` ${className}` : ''}`}
    style={style}
    draggable={false}
    {...rest}
  />
);

export default BrandLogo;
